import React, { useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import requests from '../../utils/stls/Request';
import GenericTemplate from '../../templates/GenericTemplate';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import MUIDataTable from "mui-datatables";
import FromTextFieldKojoCd from '../../components/TextField/TextFieldKojoCd';
import { chkHalfWidth, chkEmpty } from '../../common/chkTextValue';
import {Auth} from 'aws-amplify';
import moment from 'moment';

const P01Prg002Kata001: React.FC = () => {
  //変数定義
  const [post, setPosts] = useState([])
  //工場コード
  const [kojoCd, setKojoCd] = useState('');
  const [kojoCdError, setKojoCdError] = useState('');

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };

  //requests.p01Mst001KataFactoryにリクエストする関数。
  const fetchRequest = async() => {
    setPosts([])

    //requestを投げるURL作成
    const URL = process.env.REACT_APP_APIURL_STLS + requests.p01Mst001KataFactory + '/' + kojoCd
    const AuthToken = (await Auth.currentSession()).getIdToken().getJwtToken()
    axios.get(URL,
      {
        headers: {
          "X-API-KEY": process.env.REACT_APP_APIKEY_STLS || "",
          "Authorization": AuthToken || "",
        },
      }).then((res) => {
        //成功したら Posts に result を格納。
        setPosts(res.data.result)
        if (res.data.result.length === 0) {
          alert('データはありません')
        }
        console.debug(res.data.result)
      }).catch(error => {
        console.log(error);
        alert('検索に失敗しました')
      }).finally(() => {
        setLoading(false);
      });
  };

  //検索・ボタン押下時の処理 
  const handleClick = (() => {
    let errMsg = ""
    //未入力チェック
    errMsg = chkEmpty(kojoCd)
    if (errMsg.length > 0) {
      setKojoCdError(errMsg)
      alert('検索条件を入力してください');
      return;
    }
    //半角文字チェック 
    errMsg = chkHalfWidth(kojoCd)
    if (errMsg.length > 0) {
      setKojoCdError(errMsg)
      alert(errMsg);
      return;
    }

    if (!loading) {
      setSuccess(false);
      setLoading(true);
      //apiコールする関数を呼び出す
      fetchRequest()
      setSuccess(true);
    }
  })

  //入力値チェック処理：工場コード
  const chkKojoCd = (event: any) => {
    let val = event.target.value
    setKojoCdError(chkHalfWidth(val))
    setKojoCd(val)
  }

  //日付をスラッシュ編集
  function dateEditDisplay(val: string) {
    return val.length === 8 ? moment(val).format("YYYY/MM/DD") : val;
  }
  
  const column = [
    { name: "location", label: "工場コード",
      options: {
        setCellProps: () => ({ style: { position: "sticky", left: 0, background: "white", zIndex: 120 } }),
        setCellHeaderProps: () => ({ style: { position: "sticky", left: 0, background: "white", zIndex: 121 } })
      }
    },
    { name: "location_name", label: "工場名", },
    { name: "location_abbreviation", label: "工場名略称", },
    { name: "address", label: "住所", },
    { name: "phone", label: "電話番号", },
    { name: "department", label: "部門コード", },
    { name: "management_dept", label: "管理部署", },
    { name: "cost_div", label: "原価区分", },
    { name: "create_date", label: "作成日",  
      options: {
        customBodyRender:(cellValue: string) => {return dateEditDisplay(cellValue)}
      }
    },
    { name: "create_user", label: "作成者", },
    { name: "update_date", label: "更新日",  
      options: {
        customBodyRender:(cellValue: string) => {return dateEditDisplay(cellValue)}
      }
    },
    { name: "update_user", label: "更新者", },
  ];

  return (
    <GenericTemplate title="">
      <Stack spacing={1} direction="column" >
        <Stack spacing={2} direction="row">
          {/* 工場コード */}
          <FromTextFieldKojoCd onChange={chkKojoCd}
            helperText={kojoCdError}
          />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button variant="contained"
                sx={buttonSx}
                disabled={loading}
                onClick={() => { handleClick(); }}>
                検索
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                  }}
                />
              )}
            </Box>
          </Box>
        </Stack>
        <div style={{ height: '50%', width: '100%' }}>
          <MUIDataTable
            title="工場コード(stls)"
            data={post}
            columns={column}
            options={{
              selectableRows: 'none',
              rowsPerPage: 20,
              viewColumns: false,
              rowsPerPageOptions: [20, 50, 100],
              sort: false,
              print: false,
              setTableProps: () => {
                return {
                  // padding: 'none',
                  size: "small",
                  style: { whiteSpace: "nowrap" },
                };
              },
            }}
          />
        </div>
      </Stack>
    </GenericTemplate>
  )
}

export default P01Prg002Kata001